const surveyLifecycle = {
  draft: "draft",
  scheduled: "scheduled",
  live: "live",
  completed: "completed"
}

export default surveyLifecycle
